import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateIndicadorsModificats } from "../../actions/configFormularioAction";
import { crearTotOkAction } from "../../actions/ui";

const IconSave = () => (
  <svg width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M17 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V7l-4-4zm-5 16a3 3 0 110-6 3 3 0 010 6zm3-10H5V5h10v4z"/>
  </svg>
);

export const ComponenteFormularioIndicadores = ({ catIndex }) => {
  const dispatch = useDispatch();
  const { auth, configFormulario, ui } = useSelector((state) => state);
  const infoFormularioIndicadoresCategoria = configFormulario?.infoFormularioIndicadoresCategoria;
  const infoFormularioTextCategoria        = configFormulario?.infoFormularioTextCategoria;
  const pesoFinalCategoria         = infoFormularioIndicadoresCategoria?.nuevaVersion?.PesoFinalCategoria || [];
  const pesoFinalCategoriaProgramas= infoFormularioIndicadoresCategoria?.nuevaVersion?.PesoFinalCategoria_Programas || [];

  const estadoIndicadores = ui?.indicadoresState || 1;
  let valoresIniciales, sumaEsperada, datosNueva, datosActual, textosCategoria, tooltipPrefix;

  if (catIndex === 10) {
    datosNueva   = estadoIndicadores === 1 ? pesoFinalCategoria : pesoFinalCategoriaProgramas;
    datosActual  = estadoIndicadores === 1 ? infoFormularioIndicadoresCategoria?.actualVersion?.PesoFinalCategoria : infoFormularioIndicadoresCategoria?.actualVersion?.PesoFinalCategoria_Programas;
    sumaEsperada = estadoIndicadores === 1 ? 900 : 100;
  } else {
    const textosKey    = `Categoria${catIndex}`;
    const categoriaKey = estadoIndicadores === 1 ? `Categoria${catIndex}` : `Categoria${catIndex}_Programas`;
    tooltipPrefix      = estadoIndicadores === 1 ? `Cat${catIndex}_Preg` : `Cat${catIndex}_Prog`;
    datosNueva         = infoFormularioIndicadoresCategoria?.nuevaVersion?.[categoriaKey] || [];
    datosActual        = infoFormularioIndicadoresCategoria?.actualVersion?.[categoriaKey] || [];
    textosCategoria    = infoFormularioTextCategoria?.[textosKey] || {};
    sumaEsperada       = estadoIndicadores === 1 ? 100 : pesoFinalCategoriaProgramas[catIndex - 1] || 0;
  }

  const [valores, setValores] = useState(Array.isArray(datosNueva) ? datosNueva : []);

  useEffect(() => {
    setValores(Array.isArray(datosNueva) ? datosNueva : []);
  }, [catIndex, estadoIndicadores, datosNueva]);

  if (!infoFormularioIndicadoresCategoria?.nuevaVersion) {
    return <div style={{ padding:'20px 24px', color:'#dc2626', fontSize:14 }}>Error: No se encontró la información necesaria.</div>;
  }

  const actualizarValores = (index, nuevoValor) => {
    const nuevaLista = [...valores];
    nuevaLista[index] = nuevoValor;
    setValores(nuevaLista);
  };

  const guardarValores = () => {
    const sumaTotal = Math.round(valores.reduce((acc, val) => acc + val, 0));
    if (sumaTotal !== sumaEsperada) {
      alert(`La suma de los valores debe ser exactamente ${sumaEsperada}.`);
      return;
    }
    dispatch(updateIndicadorsModificats(auth.tokenJwt, valores, estadoIndicadores, catIndex, infoFormularioIndicadoresCategoria.nuevaVersion.version));
    dispatch(crearTotOkAction(estadoIndicadores === 1
      ? `Resultados de los indicadores de la categoria ${catIndex} modificados.`
      : `Resultados de los indicadores del programa ${catIndex} modificados.`
    ));
  };

  const valoresFiltradosActual = estadoIndicadores === 2 ? datosActual.filter(v => v !== 0) : datosActual;
  const valoresFiltradosNueva  = estadoIndicadores === 2 ? valores.filter(v => v !== 0) : valores;
  const sumaActual = Math.round(valores.reduce((acc, val) => acc + val, 0));
  const sumaDiff   = sumaActual - sumaEsperada;

  return (
    <div style={{ padding:'20px 24px' }}>
      {/* Indicador de suma */}
      <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:16, padding:'10px 14px', borderRadius:9, background: sumaActual === sumaEsperada ? '#f0fdf4' : '#fef2f2', border:`1px solid ${sumaActual === sumaEsperada ? '#bbf7d0' : '#fecaca'}` }}>
        <span style={{ fontSize:13, color: sumaActual === sumaEsperada ? '#15803d' : '#dc2626', fontWeight:600 }}>
          {sumaActual === sumaEsperada ? '✓' : '✗'} Suma: {sumaActual} / {sumaEsperada}
        </span>
        {sumaActual !== sumaEsperada && (
          <span style={{ fontSize:12, color:'#dc2626' }}>({sumaDiff > 0 ? '+' : ''}{sumaDiff} para completar)</span>
        )}
      </div>

      {/* Tabla */}
      <div style={{ borderRadius:10, border:'1px solid #e5e7eb', overflow:'hidden', marginBottom:16 }}>
        <table style={{ width:'100%', borderCollapse:'collapse', fontSize:14 }}>
          <thead>
            <tr style={{ background:'#f9fafb', borderBottom:'1px solid #e5e7eb' }}>
              <th style={{ padding:'10px 14px', textAlign:'left', fontSize:12, fontWeight:600, color:'#6b7280', textTransform:'uppercase', letterSpacing:'0.05em' }}>Indicador</th>
              <th style={{ padding:'10px 14px', textAlign:'center', fontSize:12, fontWeight:600, color:'#6b7280', textTransform:'uppercase', letterSpacing:'0.05em', width:110 }}>Valor actual</th>
              <th style={{ padding:'10px 14px', textAlign:'center', fontSize:12, fontWeight:600, color:'#6b7280', textTransform:'uppercase', letterSpacing:'0.05em', width:130 }}>Nuevo valor</th>
            </tr>
          </thead>
          <tbody>
            {valoresFiltradosNueva.map((valor, index) => {
              let textoReferencia;
              if (catIndex === 10) {
                textoReferencia = infoFormularioTextCategoria?.[`Categoria${index + 1}`]?.[`Cat${index+1}_Titol`];
              } else {
                textoReferencia = textosCategoria?.[`${tooltipPrefix}${index + 1}`] || "Sin información";
              }
              const changed = valor !== (valoresFiltradosActual[index] ?? valor);
              return (
                <tr key={index} style={{ borderBottom:'1px solid #f3f4f6', background: changed ? '#fffbeb' : '#fff' }}>
                  <td style={{ padding:'10px 14px', color:'#374151' }}>{textoReferencia}</td>
                  <td style={{ padding:'10px 14px', textAlign:'center', color:'#9ca3af', fontWeight:500 }}>
                    {valoresFiltradosActual[index] ?? '—'}
                  </td>
                  <td style={{ padding:'10px 14px', textAlign:'center' }}>
                    <input
                      type="number"
                      value={valor}
                      onChange={(e) => actualizarValores(index, Number(e.target.value))}
                      min="0"
                      style={{ width:90, padding:'6px 10px', fontSize:14, border:`1.5px solid ${changed?'#f59e0b':'#e5e7eb'}`, borderRadius:7, outline:'none', textAlign:'center', color:'#111827', background:'#fff' }}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

              <button onClick={guardarValores} className="u-btn-primary" style={{ display:'inline-flex', alignItems:'center', gap:7 }}>

        <IconSave /> Guardar nuevos valores
      </button>
    </div>
  );
};

